export const liveCreateRoom = {
  category: 'Add',
  action: 'live-create_room',
  label: 'Live create room'
}

export const liveCopyFromRoomList = {
  category: 'Click',
  action: 'live-copy_clipboard_from_list_of_room',
  label: 'Live copy clipboard'
}

export const liveCopyFromLive = {
  category: 'Click',
  action: 'live-copy_clipboard_from_live',
  label: 'Live copy clipboard'
}

export const liveCopyChangeNavigatorAlert = {
  category: 'Click',
  action: 'live-copy_clipboard_from_change_navigator_alert',
  label: 'Live copy clipboard'
}

export const liveSendFromRoomList = {
  category: 'Send',
  action: 'live-send_by_email_from_list_of_room',
  label: 'Live send by email'
}

export const liveSendFromLive = {
  category: 'Send',
  action: 'live-send_by_email_from_live',
  label: 'Live send by email'
}

export const liveRoomConnection = {
  category: 'Connection',
  action: 'live-room_connection',
  label: 'Live connect to room'
}

export const liveBackToRooms = {
  category: 'Click',
  action: 'live-go_back_to_rooms',
  label: 'Live go back to rooms'
}

export const liveBackToLive = {
  category: 'Click',
  action: 'live-go_back_to_live',
  label: 'Live go back to live'
}

export const liveShareScreen = {
  category: 'Click',
  action: 'live-share_screen',
  label: 'Live share screen'
}
